import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Tooltip } from 'antd';

import AlmondButterSVG from 'images/svgs/ingredients/almond.svg';
import AvocadoSVG from 'images/svgs/ingredients/avocado.svg';
import BananaSVG from 'images/svgs/ingredients/banana.svg';
import BlackberrySVG from 'images/svgs/ingredients/blackberry.svg';
import BlueberrySVG from 'images/svgs/ingredients/blueberry.svg';
import CacaoSVG from 'images/svgs/ingredients/cacao.svg';
import CarrotSVG from 'images/svgs/ingredients/carrot.svg';
import CauliflowerSVG from 'images/svgs/ingredients/cauliflower.svg';
import CherrySVG from 'images/svgs/ingredients/cherry.svg';
import CoconutSVG from 'images/svgs/ingredients/coconut.svg';
import DatesSVG from 'images/svgs/ingredients/dates.svg';
import MangoSVG from 'images/svgs/ingredients/mango.svg';
import PowerGreensSVG from 'images/svgs/ingredients/powerGreens.svg';
import PineappleSVG from 'images/svgs/ingredients/pineapple.svg';
import PumpkinSVG from 'images/svgs/ingredients/pumpkin.svg';
import PumpkinPieSpiceSVG from 'images/svgs/ingredients/pumpkinPieSpice.svg';
import PumpkinSeedsSVG from 'images/svgs/ingredients/pumpkinSeed.svg';
import RaspberriesSVG from 'images/svgs/ingredients/raspberries.svg';
import StrawberrySVG from 'images/svgs/ingredients/strawberry.svg';
import ZucchiniSVG from 'images/svgs/ingredients/zucchini.svg';

const Container = styled.div`
    height: ${({ theme, size }) => theme.image[size]};
    width: ${({ theme, size }) => theme.image[size]};
    padding: ${props => props.theme.padding.sm};
    margin: ${props => props.theme.margin.sm};
    transition: 0.1s;
    &:hover {
        filter: drop-shadow(0 2px 2px #0008);
        transform: translateY(-1px);
    }
    border-radius: 5px;
`;
const ImageIcon = styled.img`
    height: ${({ theme, size }) => theme.image[size]};
    width: ${({ theme, size }) => theme.image[size]};
`

const ingredientLookup = {
    'Almond Butter': AlmondButterSVG,
    'Avocado': AvocadoSVG,
    'Banana': BananaSVG,
    'Blackberries': BlackberrySVG,
    'Blueberries': BlueberrySVG,
    'Cacao Powder': CacaoSVG,
    'Carrot': CarrotSVG,
    'Cauliflower': CauliflowerSVG,
    'Cherries': CherrySVG,
    'Coconut Butter': CoconutSVG,
    'Dates': DatesSVG,
    'Mango': MangoSVG,
    'Pineapple': PineappleSVG,
    'Power Greens': PumpkinPieSpiceSVG,
    'Pumpkin': PumpkinSVG,
    'Pumpkin Spice': PowerGreensSVG,
    'Pumpkin Seeds': PumpkinSeedsSVG,
    'Raspberries': RaspberriesSVG,
    'Strawberries': StrawberrySVG,
    'Zucchini': ZucchiniSVG,
}

const propTypes = {};
const Ingredient = ({ ingredient, size }) => (
    <Tooltip placement="bottom" title={ingredient}>
        <Container size={size}>
            <ImageIcon src={ingredientLookup[ingredient] || StrawberrySVG} size={size} />
        </Container>
    </Tooltip>
);

Ingredient.propTypes = propTypes;
export { Ingredient };


// WEBPACK FOOTER //
// ./src/sc-ui/Ingredient.jsx